import { ExtraOptions, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { authGuard } from './_guard/auth.guard';
// import { isAdmin } from './_guard/privilage.guard';

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled',
};

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    // data: { breadcrumb: 'Siamese Rental Admin' },
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
          data: { breadcrumb: 'แดชบอร์ด' }
      },
      {
        path: 'quotation',
        loadChildren: () =>
          import('./modules/quotation/quotation-page.module').then(
            (m) => m.QuotationPageModule
          ),
          data: { breadcrumb: 'ใบเสนอราคา' },
      },
      {
        path: 'contract',
        loadChildren: () =>
          import('./modules/contract/contact-page.module').then(
            (m) => m.ContactPageModule
          ),
          data: { breadcrumb: 'ใบสัญญา' },
      },
      {
        path: 'invoice',
        loadChildren: () =>
          import('./modules/invoice/invoice.module').then(
            (m) => m.InvoiceModule
          ),
          data: { breadcrumb: 'ใบแจ้งหนี้' },
      },
      {
        path: 'price-approval',
        loadChildren: () =>
          import('./modules/price-approval/price-approval.module').then(
            (m) => m.PriceApprovalModule
          ),
          data: { breadcrumb: 'อนุมัติแก้ไขราคา' },
      },
      {
        path: 'receipt',
        loadChildren: () =>
          import('./modules/reciept/reciept.module').then(
            (m) => m.RecieptModule
          ),
          data: { breadcrumb: 'ใบเสร็จรับเงิน' },
      },
      {
        path: 'manage-user',
        loadChildren: () =>
          import('./modules/manage-user/manage-user-page.module').then(
            (m) => m.ManageUserPageModule
          ),
          data: { breadcrumb: 'การจัดการผู้ใช้งาน' },
        // canActivate: [isAdmin],
      },
      {
        path: 'user-profile',
        loadChildren: () =>
          import('./modules/user-profile/user-profile.module').then(
          (m) => m.UserProfileModule
        ),
        data: { breadcrumb: 'บัญชีส่วนตัว' },
      },
      {
        path: 'project',
        loadChildren: () =>
          import('./modules/project/project-routing.module').then(
            (m) => m.ProjectRoutingModule
          ),
          data: { breadcrumb: 'โปรเจค' },
      },
      {
        path: 'promotion',
        loadChildren: () =>
          import('./modules/promotion/promotion-routing.module').then(
            (m) => m.PromotionRoutingModule
          ),
          data: { breadcrumb: 'โปรโมชัน' },
      },
      {
        path: 'import',
        loadChildren: () =>
          import('./modules/import/import.module').then(
            (m) => m.ImportModule
          ),
          data: { breadcrumb: 'นำเข้า' },
      },
      {
        path: 'meter',
        loadChildren: () =>
          import('./modules/meter/meter.module').then(
            (m) => m.MeterModule
          ),
          data: { breadcrumb: 'มิเตอร์' },
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./modules/customer/customer.module').then(
            (m) => m.CustomerModule
          ),
          data: { breadcrumb: 'ลูกค้า' },
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./modules/report/report.module').then(
            (m) => m.ReportModule
          ),
          data: { breadcrumb: 'รายงาน' },
      }
      
    ],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
];
